import { Button } from '@/components/ui/button';
import { PhotoPicker, type PickedPhoto } from '@/components/mobile/PhotoPicker';

interface Props {
    photos: PickedPhoto[];
    onChange: (photos: PickedPhoto[]) => void;
    upload: (file: File, onProgress: (pct: number) => void) => Promise<{ fileId: string }>;
    canSubmit: boolean; submitting: boolean; onSubmit: () => void;
    /** Ce se asteapta aici, pe tipul activitatii (ex. „Poze cu fișele completate sau PDF, maximum 5."). */
    indicatie: string;
}

/**
 * Pasul 4: dovezile - poze sau PDF, ca la profesor (din 2026-10-05; pana atunci doar poze).
 * `constrainGrid` cere lui `PhotoPicker` sa limiteze singur grila la inaltime (F2.4) - butoanele
 * Fa o poza / Alege din galerie (≥56px) si CTA-ul de mai jos raman mereu vizibile, fara sa impinga
 * pagina la scroll. E o EXCEPTIE de la regula generala „un singur scroll pe ecran" (R4/F6), valabila
 * DOAR pentru pagina publica: fluxul de lectie randeaza acelasi `PhotoPicker` in interiorul
 * singurului scroll de pe ecranul lui (`LessonPlayer.tsx`), deci acolo `constrainGrid` NU se paseaza.
 */
export function StepPhotos({ photos, onChange, upload, canSubmit, submitting, onSubmit, indicatie }: Props) {
    return (
        <div className="flex flex-col gap-4">
            <p className="text-sm text-pretty text-dark/70" data-colab-indicatie-fisiere>{indicatie}</p>
            <PhotoPicker photos={photos} onChange={onChange} upload={upload} max={5} disabled={submitting} constrainGrid acceptPdf />
            <Button type="button" className="min-h-12 w-full" disabled={!canSubmit || submitting} onClick={onSubmit}>
                {submitting ? 'Se trimite…' : 'Trimite'}
            </Button>
        </div>
    );
}
